import styled from 'styled-components';
import tw from 'twin.macro';
import TitleHeader from '../../components/TitleHeader/TitleHeader';

// eslint-disable-next-line import/prefer-default-export
export const TitleHeaderForEventGroup = styled(TitleHeader).attrs(() => ({
  variant: 'secondary',
  truncate: true
}))(({ followedByOtherHeader }) => [
  tw`px-0 bg-silver-lighten-30 pr-16`,
  !followedByOtherHeader && tw`mb-8`
]);
